import { render, staticRenderFns } from "./CreateOrder.vue?vue&type=template&id=67d97b6c&scoped=true"
import script from "./CreateOrder.vue?vue&type=script&lang=js"
export * from "./CreateOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d97b6c",
  null
  
)

export default component.exports